import { useState, useEffect } from 'react';
import PaymentsPanel from '@/components/admin/PaymentsPanel';
import { API } from '@/App';

export default function AdminPaymentsPage() {
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API}/admin/payments`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        setPayments(await response.json());
      }
    } catch (error) {
      console.error('Error fetching payments:', error);
    }
  };

  return <PaymentsPanel payments={payments} />;
}
